import * as XLSX from "xlsx";
export function getPortalPlatform() {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  console.log("isiOS------" + isiOS);
  if (isiOS) {
    return "ios";
  } else {
    return "andriod";
  }
}
export function handtime(time) {
  if (time) {
    // console.log(time);
    // var date =new Date(time)
    // var year =date.getFullYear()
    // var month =date.getMonth()+1 >9 ?date.getMonth()+1 :"0"+(date.getMonth()+1);
    // var day =date.getDate()>9 ?date.getDate() :"0"+date.getDate();
    // var hours=date.getHours()>9 ?date.getHours() :"0"+date.getHours();
    // var minutes=date.getMinutes() >9 ? date.getMinutes() : "0"+ date.getMinutes();
    // var seconds=date.getSeconds() >9 ?date.getSeconds() : "0" +date.getSeconds();
    // return year + "-" +month+"-"+day +" "+hours+":"+minutes+":"+seconds
    return time.replace("T", " ").slice(0, -1);
  } else {
    return "-";
  }
}
export function getPlatform() {
  let native;
  let p = navigator.platform;
  let u = navigator.userAgent;
  let is_android = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
  let is_ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (
    p == "Win32" ||
    p == "Win64" ||
    p == "MacPPC" ||
    p == "MacIntel" ||
    p == "X11" ||
    p == "Linux i686"
  ) {
    //PC调试环境
    console.log("PC环境--供PC端调试");
    native = new EmptyNative();
  } else {
    if (is_android) {
      //Android终端
      console.log("Mobile环境--Android移动端");
      native = new AndroidNative();
    } else if (is_ios) {
      //IOS终端
      console.log("Mobile环境--IOS移动端");
      native = new IOSNative();
    }
  }
}
export function appSource() {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS) {
    return "ios";
  } else {
    return "andriod";
  }
}

export function isiOS() {
  let u = appSource();
  if (u === "ios") {
    return true;
  }
  return false;
}

export function isAndroid() {
  let u = appSource();
  if (u === "andriod") {
    return true;
  }
  return false;
}

export function todayDate() {
  let dt, y, m, d, w;
  dt = new Date();
  y = dt.getFullYear();
  m = dt.getMonth() + 1;
  d = dt.getDate();
  w = dt.getDay();
  let weeks = ["天", "一", "二", "三", "四", "五", "六"];
  return `${y} 年 ${m.toString().padStart(2, "0")} 月 ${d
    .toString()
    .padStart(2, "0")} 日 星期${weeks[w]}`;
}
export function adaptive() {
  function resize() {
    let designWidth = 750; // 移动端设计稿标准宽度---》基于iphone6
    let baseFontSize = 10; // 设计稿100px相当于1rem， 750px --> 7.5rem ---> 各种屏幕的100%的宽度
    let width = window.innerWidth; // 屏幕宽度
    let currentFontSize = (width / designWidth) * baseFontSize;
    document.querySelector("html").style.fontSize = currentFontSize + "px";
  }
  // 1.当屏幕缩小时会触发该事件
  window.onresize = function () {
    resize();
  };
  // 2.监听DOMContentLoaded事件， 当浏览器解析完文档触发该事件
  document.addEventListener("DOMContentLoaded", resize);
}

export function dealSize(size) {
  let value;
  const re = /^[0-9]+.?[0-9]*$/;
  if (re.test(size)) {
    if (size < 1024) {
      value = size + "B";
    } else if (size >= 1024 && size < 1048576) {
      value = Math.round((size / 1024) * 100) / 100 + "KB";
    } else if (size >= 1048576 && size < 1073741824) {
      value = Math.round((size / 1048576) * 100) / 100 + "MB";
    } else {
      value = Math.round((size / 1073741824) * 100) / 100 + "GB";
    }
  } else {
    value = "--";
  }
  return value;
}
// 获取昨日的日期时间
export function getYesterday() {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const year = yesterday.getFullYear();
  const month = String(yesterday.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
  const day = String(yesterday.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
// 格式化日期时间
export function formatDate(date, format) {
  const weekday = ["日", "一", "二", "三", "四", "五", "六"];
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  const week = date.getDay();
  const padZero = (value) => String(value).padStart(2, "0");

  const formatObj = {
    YYYY: year,
    MM: padZero(month),
    M: month,
    DD: padZero(day),
    D: day,
    HH: padZero(hour),
    mm: padZero(minute),
    ss: padZero(second),
    ww: "周" + weekday[week],
  };

  return format.replace(
    /YYYY|MM|M|DD|D|HH|mm|ss|ww/g,
    (match) => formatObj[match]
  );
}
// 处理树形数组
export function transformTreeData(data, depth = 1) {
  if (!data || data.length === 0) {
    return [];
  }

  return data.map((item) => {
    const addChildren = depth < 5; // 设置 addChildren 值

    const newItem = {
      ...item,
      isFirst: depth === 1,
      addChildren: addChildren,
    };

    if (item.children && item.children.length > 0) {
      newItem.children = transformTreeData(item.children, depth + 1); // 递归处理子节点，增加深度
    }

    return newItem;
  });
}
// 树形数组转平铺数组
export function flattenTree(tree) {
  let flatArray = [];

  for (const node of tree) {
    // 复制节点数据，排除子节点
    const { children, pid, level_status, ...rest } = node;

    // 添加父节点ID和层级信息
    const flatNode = {
      ...rest,
      pid,
      level_status,
    };

    flatArray.push(flatNode);

    // 如果有子节点，递归处理
    if (node.children && node.children.length > 0) {
      flatArray = flatArray.concat(flattenTree(node.children));
    }
  }

  return flatArray;
}
// 格式化树形数组键名
export function transformKeys(tree) {
  if (Array.isArray(tree)) {
    return tree.map((node) => transformKeys(node));
  } else if (typeof tree === "object" && tree !== null) {
    const { name, id, children, ...rest } = tree;
    return {
      label: name,
      value: id,
      ...(children &&
        children.length > 0 && { children: transformKeys(children) }),
      ...rest,
    };
  }
  return tree;
}
// 表格数据转换
export function tableDataTransform(data) {
  const copyData = JSON.parse(JSON.stringify(data));
  const keyMap = {
    batch_number: "批次号",
    code_name: "设备型号",
    device_class_name: "设备类型",
    sn: "SN",
    imei: "IMEI",
    mac: "Mac地址",
    business_name: "商户名称",
    institution_name: "机构名称",
    firmware_version: "固件版本",
    production_type: "生产类型",
    manufacturer_name: "生产厂商",
    language: "语言",
    // uid: "绑定用户",
    // first_bind_time: "首次绑定日期",
    // warranty: "保修",
    // created_at: "入库绑定日期",
    // status: "状态",
    // _id: "设备编码",
  };
  const chineseData = copyData.map((item) => {
    const newItem = {};
    const orderedKeys = Object.keys(keyMap);
    orderedKeys.forEach((key) => {
      if (key === "language") {
        item[key] = item[key] === 1 ? "中文" : item[key] === 2 ? "英文" : "";
      } else if (key === "production_type") {
        item[key] = item[key] === 1 ? "量产" : item[key] === 2 ? "试产" : "";
      } else if (key === "status") {
        item[key] = item[key] ? "启用" : "停用";
      }
      newItem[keyMap[key]] = item[key];
    });
    return newItem;
  });
  return chineseData;
}
// 活动表格数据转换
export function activeTableDataTransform(data) {
  const copyData = JSON.parse(JSON.stringify(data));
  const keyMap = {
    deviceType: "设备型号",
    deviceId: "设备编码",
    createdAt: "添加时间",
    status: "状态",
    firstBindTime: "激活时间",
  };
  const chineseData = copyData.map((item, index) => {
    const newItem = {};
    const orderedKeys = Object.keys(keyMap);

    // 添加序号字段，index + 1 从 1 开始
    newItem["序号"] = index + 1;
    orderedKeys.forEach((key) => {
      newItem[keyMap[key]] = item[key];
    });
    return newItem;
  });
  return chineseData;
}
// 表格数据导出
export function exportToExcel(data, fileName) {
  const ws = XLSX.utils.json_to_sheet(data);
  // 获取所有单元格的范围
  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const col = XLSX.utils.encode_col(C);
    let maxColWidth = 0;
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const cell = ws[col + R];
      if (!cell) continue;
      const cellText = cell.v + ""; // 将单元格的值转化为字符串
      const cellWidth = (cellText.length + 2) * 1.2; // 自定义宽度计算
      if (cellWidth > maxColWidth) {
        maxColWidth = cellWidth;
      }
    }
    // 设置列宽
    ws["!cols"] = ws["!cols"] || [];
    ws["!cols"][C] = { wch: maxColWidth };
  }
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, fileName + ".xlsx");
}

const Envs = {
  cn: {
    hostName: "cn.admin.yanhezhineng.com",
    apiUrl: "https://cn.admin.api.yanhezhineng.com",
    downloadUrl: "https://cn.api.yanhezhineng.com/yhe",
    title: "国内",
    isZh: true,
  },
  en: {
    hostName: "admin.yanhezhineng.com",
    apiUrl: "https://admin.api.yanhezhineng.com",
    downloadUrl: "https://api.yanhezhineng.com/yhe",
    title: "国际",
    isZh: false,
  },
  test: {
    hostName: "admin.yanhezhineng.cn",
    apiUrl: "http://api.admin.yanhezhineng.cn",
    downloadUrl: "http://api.yanhezhineng.cn/yhe",
    title: "测试",
    isZh: false,
  },
  dev: {
    hostName: "localhost",
    apiUrl: process.env.VUE_APP_baseUrl,
    downloadUrl: "http://api.yanhezhineng.cn/yhe",
    title: "本地",
    isZh: false,
  },
};

export function env() {
  const hostname = window.location.hostname;
  return (
    Object.values(Envs).find((e) => e.hostName === hostname) || Envs["dev"]
  );
}

export function getDictMap() {
  const DICT = JSON.parse(localStorage.getItem("DICT_ALL") || "[]");
  const DMAP = {};
  const arr = [...DICT];
  while (arr.length) {
    const item = arr.shift();
    DMAP[item.id] = item;
    DMAP[item.code] = item;
    arr.push(...(item.children || []));
  }
  return DMAP;
}

export function getCurrentUser() {
  return JSON.parse(localStorage.getItem("userInfo") || "{}");
}